// Partner MCP core — proposals inbox store (Rammeverket, B; plan docs/superpowers/plans/2026-10-21-partner-mcp-dj-proposals.md).

import { observable, computed } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

// Inbox of AI-created proposals (GET /api/mcp-proposals). Applying or
// dismissing goes through explicit POSTs, then the list is reloaded.
export class McpProposalStore extends LocalModel {
    @observable mcpProposals = [];

    @observable loading = false;

    @observable error = '';

    // { [proposalId]: true } while an apply request is in flight.
    @observable applying = {};

    constructor() {
        super('mcpProposal', {
            namePlural: 'mcpProposals',
            namePluralReal: 'mcp-proposals',
            api: {
                search: { url: '/api/mcp-proposals/', params: {} },
                load: { url: '/api/mcp-proposals/', params: {} },
                save: { url: '/api/mcp-proposals/', params: {} },
                delete: { url: '/api/mcp-proposals/', params: {} },
            },
        });
    }

    async load() {
        this.updateKeyValue('loading', true);
        const response = await util.fetchApi('/api/mcp-proposals', { method: 'GET' });
        if (response && response.status === 200) {
            const items = response.data && Array.isArray(response.data.items) ? response.data.items : [];
            this.updateKeyValue('mcpProposals', items);
            this.updateKeyValue('error', '');
        } else {
            this.updateKeyValue('error', (response && response.message) || 'Kunne ikke laste forslag');
        }
        this.updateKeyValue('loading', false);
    }

    async apply(id) {
        this.updateObjectKeyValue('applying', id, true);
        const response = await util.fetchApi(`/api/mcp-proposals/${id}/apply`, { method: 'POST' }, {});
        this.updateObjectKeyValue('applying', id, false);
        await this.load();
        if (response && response.status >= 400) {
            this.updateKeyValue('error', response.message || 'Kunne ikke opprette');
        }
        return response;
    }

    // A refused dismiss (e.g. 409 APPLY_IN_PROGRESS while a step is being created) is shown, not swallowed.
    // The error is set after the reload, because a successful load() clears it.
    async dismiss(id) {
        const response = await util.fetchApi(`/api/mcp-proposals/${id}/decide`, { method: 'POST' }, { status: 'dismissed' });
        await this.load();
        if (!response || response.status >= 400) {
            this.updateKeyValue('error', (response && response.message) || 'Kunne ikke avvise');
        }
        return response;
    }

    @computed
    get pendingCount() {
        return this.mcpProposals.filter(p => p.status === 'pending' || p.status === 'partial').length;
    }
}

const mcpProposalStore = new McpProposalStore();
export default mcpProposalStore;
